<div class="flex flex-1 px-10 py-5 border-t">
	<div class="flex flex-1">
		<app-button
			btn="tertiary"
			(click)="back()"
			*ngIf="showBack"
			size="small"
			[testHook]="testHooks.BackButton"
			>Back</app-button
		>
	</div>

	<div class="flex flex-1 justify-self-center">
		<ng-content></ng-content>
	</div>

	<div class="flex justify-self-end">
		<app-button
			btn="secondary"
			class="mr-10"
			(click)="skip()"
			*ngIf="showSkip"
			size="small"
			[testHook]="testHooks.SkipToOverviewButton"
		>
			Skip to overview
		</app-button>
		<app-button (click)="next()" size="small" [testHook]="testHooks.NextButton">
			{{ nextLabel }}
			<app-icon
				[icon]="ICON.RIGHT"
				class="ml-2"
				[testHook]="testHooks.RightIcon"
			></app-icon>
		</app-button>
	</div>
</div>
